const roles = [
  { id: 1, role: "user" },
  { id: 2, role: "inventry" },
  { id: 3, role: "admin" },
];

export default roles;